import { render, staticRenderFns } from "./OnboardingCongratulations.vue?vue&type=template&id=22ba24d7&scoped=true&lang=pug&"
import script from "./OnboardingCongratulations.vue?vue&type=script&lang=js&"
export * from "./OnboardingCongratulations.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCongratulations.vue?vue&type=style&index=0&id=22ba24d7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba24d7",
  null
  
)

export default component.exports